import { render, staticRenderFns } from "./ChannelConfig.vue?vue&type=template&id=81492cfe&scoped=true"
import script from "./ChannelConfig.vue?vue&type=script&lang=js"
export * from "./ChannelConfig.vue?vue&type=script&lang=js"
import style0 from "./ChannelConfig.vue?vue&type=style&index=0&id=81492cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81492cfe",
  null
  
)

export default component.exports